import React, { useEffect, useState } from "react";

interface FormattedNumberInputProps {
  defaultValue?: number;
  className?: string;
  placeholder?: string;
  onChange?: (value: number) => void;
}

const FormattedNumberInput: React.FC<FormattedNumberInputProps> = ({
  defaultValue,
  className,
  placeholder,
  onChange,
}) => {
  const formatNumber = (value: string): string => {
    const numericValue = value?.replace(/\D/g, "");
    return numericValue
      ? numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      : "";
  };

  const [formattedNumber, setFormattedNumber] = useState<string>(
    defaultValue !== undefined ? formatNumber(defaultValue?.toString()) : ""
  );

  useEffect(() => {
    if (defaultValue !== undefined) {
      setFormattedNumber(formatNumber(defaultValue?.toString()));
    }
  }, [defaultValue]);

  useEffect(() => {
    if (
      onChange &&
      formattedNumber !== "" &&
      defaultValue?.toString() !== formattedNumber
    ) {
      onChange(unFormatNumber(formattedNumber));
    }
  }, [formattedNumber, onChange]);

  const unFormatNumber = (value: string): number => {
    const parsed = parseFloat(value?.replace(/,/g, ""));
    return isNaN(parsed) ? 0 : parsed;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setFormattedNumber(inputValue); // Don't format immediately
  };

  const handleBlur = () => {
    setFormattedNumber(formatNumber(formattedNumber)); // Format on blur
  };

  return (
    <input
      type="text"
      className={className}
      placeholder={placeholder || ""}
      value={formattedNumber}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default FormattedNumberInput;
